export default {
  switcher: "Workspaces",
  loadFailed: "Could not load workspaces.",
  reader: "Reader",
  writer: "Writer",
  organizer: "Organizer",
  union: "Union",
  catalog: "Cataloguing",
  administrator: "Administrator",
  analytics: "Analytics",
  profile: "Profile",
  summary: "Summary",
  myCabinets: "My workspaces",
  openSidebar: "Open workspace menu",
  closeSidebar: "Close workspace menu",
  nav: {
    profile: "Profile",
    overview: "Overview",
    anketa: "Profile and password",
    analyticsOverview: "Overview",
  },
  groups: {
    sections: "Sections",
    management: "Management",
    administration: "Administration",
    audit: "Audit",
  },
  summaryPage: {
    title: "Summary",
    subtitle: "All your roles on one screen. Pick a workspace to continue.",
    open: "Open workspace",
    pending_one: "{{count}} task needs attention",
    pending_other: "{{count}} tasks need attention",
    nothingPending: "No new tasks",
    profileHint: "Profile, notifications and event registrations.",
  },
  hints: {
    reader: "Event registrations, collections, notifications and profile.",
    writer: "Writer profile, portfolio, union application and deposits.",
    organizer: "Creating events, attendance and moderation.",
    union: "Membership applications, member registry and work verification.",
    catalog: "Catalogue records, error reports, dictionaries, import, moderation and statistics.",
    administrator: "Users, roles, associations and audit journals.",
    analytics: "Catalogue and portal statistics.",
  },
  pendingBadge: "Tasks: {{count}}",
}
